import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=1eeb1e52&scoped=true"
import script from "./FormBody.vue?vue&type=script&lang=js"
export * from "./FormBody.vue?vue&type=script&lang=js"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=1eeb1e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb1e52",
  null
  
)

export default component.exports